<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Submission Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="submitForm">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted">Submission</span>
            </b-card-header>

            <div class="py-3 px-4">
              <b-form-group label="Field ID" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.identifier"
                  placeholder="Submission Name"
                  :state="!$v.form_data.identifier.$invalid"
                />
              </b-form-group>

              <b-form-group label="Event Code" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.event_code"
                  placeholder="Submission Event Code (optional)"
                  :state="!$v.form_data.event_code.$invalid"
                />
              </b-form-group>

              <b-form-group label="Note" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.note"
                  placeholder="Note"
                  :state="!$v.form_data.note.$invalid"
                />
              </b-form-group>

              <b-form-group
                label="Turnaround"
                :label-cols="2"
                invalid-feedback="Required"
                :state="!$v.form_data.turnaround_id.$invalid"
                :horizontal="true"
              >
                <custom-form-radio-group :options="options" v-model="form_data.turnaround_id" />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">
                Reason for Update
              </span>
            </b-card-header>

            <b-card-body>
              <b-form-group label="Reason for Update" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.update_reason"
                  placeholder="Update Reason"
                  :state="!$v.form_data.update_reason.$invalid"
                />
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            type="submit"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import CustomFormRadioGroup from '@/components/shared/form/CustomFormRadioGroup'
import { getCollection } from '@/shared/fetch-utils'
import { requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'SubmissionForm',
  components: { CustomFormRadioGroup },
  mixins: [validationMixin],
  props: {
    submission: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: true,
      form_data: {
        identifier: null,
        event_code: null,
        note: null,
        turnaround_id: null,
        update_reason: null
      },
      turn_arounds: null
    }
  },
  computed: {
    options () {
      return this.turn_arounds ? this.turn_arounds.map(i => ({
        value: i.id,
        text: `${i.name}<br /><small>${this.formatSurchage(i)}</small>`,
        icon: 'hourglass'
      })) : []
    }
  },
  validations: {
    form_data: {
      identifier: { required },
      event_code: { required },
      note: {},
      turnaround_id: { required },
      update_reason: {
        required: requiredIf(function () {
          return this.submission && this.submission.id
        })
      }
    },
  },
  async created () {
    this.loading = true

    this.turn_arounds = await getCollection({
      collection_type: 'turnaround',
      filters: [
        {
          logic: "filterEquals",
          field: "sample_type_id",
          value: this.submission.sample_type_id
        },
        {
          logic: "filterEquals",
          field: "active",
          value: 1
        }
      ],
      limit: "all",
      message: this.$bvToast
    })

    this.initFormData()
    this.loading = false
  },
  methods: {
    formatSurchage(turnAround) {
      switch (turnAround.surcharge_type) {
        case "percent":
          return `${turnAround.surcharge}% Surcharge`;
        case "flat":
          return `$${turnAround.surcharge} Surcharge`;
      }
      return "Surcharge not specified";
    },
    initFormData () {
      this.form_data = {
        ...this.submission.cloneAttributes(true, true, ["id", "pid", "update_reason"]),
      }
    },
    submitForm () {
      this.$v.$touch()
      if (this.invalid) return

      return this.$emit('submit', this.form_data)
    }
  }
}
</script>
